import React, { useState } from 'react';
import PropTypes from 'prop-types';
import CircularProgress from '@material-ui/core/CircularProgress';
import {
  AvatarContainer,
  Image,
  BaseText,
  OnlineIndicatorBadge,
} from './Avatar.style';

const Avatar = ({
  size,
  name,
  online,
  src,
  colourSeed,
  className,
  attributes: { container: containerAttributes },
  events,
}) => {
  const hasImage = !!src;
  const [isLoaded, setLoaded] = useState(false);

  return (
    <AvatarContainer
      size={size}
      hasImage={hasImage}
      name={colourSeed || name}
      className={className}
      {...containerAttributes}
      {...events}
    >
      {hasImage ? (
        <Image
          size={size}
          src={src}
          alt={name}
          onLoad={() => setLoaded(true)}
        />
      ) : (
        <BaseText aria-hidden="true">{name && name[0]}</BaseText>
      )}
      {hasImage && !isLoaded && <CircularProgress size={24} />}
      {online && <OnlineIndicatorBadge aria-label="online-status" />}
    </AvatarContainer>
  );
};

Avatar.defaultProps = {
  size: 'medium',
  online: false,
  src: null,
  colourSeed: null,
  className: undefined,
  attributes: {},
  events: {},
};

Avatar.propTypes = {
  /** The size of the avatar */
  size: PropTypes.oneOf(['small', 'medium', 'large', 'xLarge']),

  /** Name of the avatar's user, for placeholder avatar. */
  name: PropTypes.string.isRequired,

  /** Used for indicating online status of the user */
  online: PropTypes.bool,

  /** URL of the avatar image */
  src: PropTypes.string,
  /** String used as the seed to pick a background colour for the avatar.
  A correlation id, request id or user id would be an appropriate value. */
  colourSeed: PropTypes.string,

  className: PropTypes.string,
  attributes: PropTypes.shape({ container: PropTypes.object }),
  events: PropTypes.shape({ onKeyPress: PropTypes.func }),
};

export default React.memo(Avatar);
